import React from "react";
import logoimage from "src/components/ui/images/aboutnew.jpeg";

const AboutSection = () => {
  return (
    <section id="about" className="py-20 bg-red-600">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
            The Story of 
            <span className="text-black">
              {" "}
              Clara Boxing Academy 
            </span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <div>
             <div className="text-center">
  <h3 className="text-3xl font-bold text-white mb-4">
    Founders
  </h3>
  <p className="text-xl font-semibold text-white mb-6 tracking-[0.3em]">
    Rene & Michelle
  </p>
</div>

 <h3 className="text-black text-2xl font-bold mb-4">
  Where It All Began
</h3>
<p className="text-gray-300 text-lg leading-relaxed mb-6">
  In 2020, Rene and Michelle met, and from the beginning boxing became part of their shared life. Rene had been introduced to the sport through his brother, and Michelle stepped into that world alongside him. Together, they went from gym to gym supporting sparring sessions, training days, and fight nights. They experienced the discipline, the culture, and the grind of boxing side by side.
</p>

<h3 className="text-black text-2xl font-bold mb-4">
  When Support Became Purpose
</h3>
<p className="text-gray-300 text-lg leading-relaxed mb-6">
  Over time, what began as support transformed into purpose for them both. Michelle was present the first time Rene put on the mitts, and it was immediately clear he belonged there. It felt natural, confident, and steady.
</p>
<p className="text-gray-300 text-lg leading-relaxed mb-6">
  They both saw it. That moment marked a shift from observing the sport to stepping into it.
</p>
<p className="text-gray-300 text-lg leading-relaxed mb-6">
  When Rene began leading more consistently, Michelle stood behind him without hesitation. For his birthday, she gifted him his first set of mitts, a symbol of her belief in the coach he was becoming.
</p>
<p className="text-gray-300 text-lg leading-relaxed mb-6">
  Not long after, they sat down together and talked about building something of their own, something that would bring a boxing community together.
</p>

<h3 className="text-black text-2xl font-bold mb-4">
  The Foundation
</h3>
<p className="text-gray-300 text-lg leading-relaxed mb-6">
  In October 2023, they turned the garage of the home they were renting into a training space of their own. The garage was small, but the vision was big. They cleared it out themselves and drove hours for second-hand equipment from Facebook Marketplace, building it piece by piece with consistency and commitment.
</p>
<p className="text-gray-300 text-lg leading-relaxed mb-6">
  Rain or shine. Cold or hot. People showed up. Athletes began joining them in that small garage, drawn to the structure and environment they were creating together.
</p>

<h3 className="text-black text-2xl font-bold mb-4">
  Growing Beyond the Garage
</h3>
<p className="text-gray-300 text-lg leading-relaxed mb-6">
  While they both continue to work outside of the gym to provide for their family, the gym remains their passion, and they reinvest into its growth every step of the way.
</p>
<p className="text-gray-300 text-lg leading-relaxed mb-6">
  As the community grew, they outgrew the garage. To welcome more people and continue expanding their vision, they opened their first official facility in Melrose Park in February 2025.
</p>

<h3 className="text-black text-2xl font-bold mb-4">
  Who We Are Today
</h3>
<p className="text-gray-300 text-lg leading-relaxed mb-6">
  Today, Rene leads the training side of the academy. His attention is fully dedicated to coaching, training athletes, sharpening his own skills, and developing disciplined boxers at every level.
</p>
<p className="text-gray-300 text-lg leading-relaxed mb-6">
  Michelle handles the entire business side of the academy. She leads the marketing and exposure for the gym, reinvests into equipment, ensures the doors stay open, and works every day to make the academy grow. She focuses on creating an environment where people walk in feeling supported, motivated, and part of something positive.
</p>

<h3 className="text-black text-2xl font-bold mb-4">
  A Family Story
</h3>
<p className="text-gray-300 text-lg leading-relaxed mb-6">
  Clara Boxing Academy is more than a business; it is part of their family’s journey. Their daughter, Adelaila, has been there since the beginning. Whether she is watching sparring from the corner, putting on gloves she finds around the gym, hitting the bags, or dancing in the ring, she represents the heart behind what they are building.
</p>

<h3 className="text-black text-2xl font-bold mb-4">
  A Place for Everyone
</h3>
<p className="text-gray-300 text-lg leading-relaxed">
  Clara Boxing Academy is for every age, every level, and every goal. Rooted in family and driven by community, this is a place where people walk in supported, challenged, and encouraged to become better every day!
</p>
</div>
</div>


          <div className="relative">
            <div className="relative overflow-hidden rounded-lg bg-black/10">
              <img
                src={logoimage}
                alt="Boxing training at Clara Boxing Academy"
                className="w-full h-[28rem] object-cover object-center"
              />
              <div className="absolute inset-0 bg-red-600/20"></div>
            </div>

            <div className="absolute -bottom-14 -right-4 bg-black border border-white text-white p-6 rounded-lg shadow-lg">
              <p className="font-bold text-lg">Family-Run</p>
              <p className="text-sm">Since Day One</p>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="inline-block bg-black border border-white rounded-lg p-8 max-w-2xl">
            <p className="text-white text-xl font-semibold mb-4">
              "No matter your age, experience, or goals, you're welcome here."
            </p>
            <p className="text-gray-300">
              Clara Boxing Academy is a place for anyone ready to learn, grow,
              and become stronger—both in and out of the ring.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
